<template>
  <el-dialog
    class="comp-container"
    :visible.sync="endClassVisible"
    width="30%"
    top="30vh"
    custom-class="comfirm-remove-dialog"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="error-content">
      <img src="@saas/pages/assets/images/live/error.png" alt="" />
      {{ errorInfo.errorMessage }}
      <!-- <span class="error-code">错误码：{{ errorInfo.errorCode }}</span> -->
    </div>
    <div class="error-footer">
      <!-- <el-button type="primary" @click="handleToSettings"> 测试 </el-button> -->
      <el-button v-if="showCancel" @click="handleClose">取消</el-button>
      <el-button v-if="showReEnterRoom" type="primary" @click="handleEnterRoom">
        重新进入
      </el-button>
      <el-button
        v-else-if="showToSettings"
        type="primary"
        @click="handleToSettings"
      >
        去设置
      </el-button>
      <el-button v-else-if="showRefresh" type="primary" @click="handleRefresh">
        刷新
      </el-button>
      <el-button
        v-else-if="showNewScreenShare"
        type="primary"
        @click="handleNewScreenShare"
      >
        开启新的共享
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  props: {},
  data() {
    return {
      endClassVisible: false,
      isElectron: !!window.isElectron,
    };
  },
  computed: {
    ...mapState("live", [
      "liveService",
      "imService",
      "errorVisible",
      "errorInfo",
      "screenShareStatus",
    ]),
    showCancel() {
      return this.errorInfo.errorType !== "enterRoom" || !this.isElectron;
    },
    showRefresh() {
      if (this.isElectron) {
        return this.errorInfo.errorType === "codec";
      } else {
        return true;
      }
    },
    showReEnterRoom() {
      return this.errorInfo.errorType === "enterRoom" && this.isElectron;
    },
    showToSettings() {
      return (
        ["camera", "microphone", "speaker"].includes(
          this.errorInfo.errorType
        ) && this.isElectron
      );
    },
    showNewScreenShare() {
      return this.errorInfo.errorType === "screenShare";
    },
  },
  methods: {
    ...mapMutations("live", ["setShowScreenShareDialog", "setErrorVisible"]),
    handleRefresh() {
      window.location.reload();
    },
    handleClose() {
      this.endClassVisible = false;
      this.setErrorVisible(false);
    },
    open() {
      this.endClassVisible = true;
    },
    handleEnterRoom() {
      window.location.reload();
    },
    handleToSettings() {
      this.setErrorVisible(false);
      if (!this.isElectron || !window.LiveElectronApi) {
        return;
      }
      const type = this.errorInfo.errorType || "general";
      if (window.LiveElectronApi.openSystemSettings) {
        window.LiveElectronApi.openSystemSettings(type);
      }
    },
    handleNewScreenShare() {
      this.setErrorVisible(false);
      if (window.isElectron && this.errorInfo.errorType === "screenShare") {
        // 录屏错误 结束共享并且打开共享弹窗
        this.setShowScreenShareDialog(true);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.comp-container ::v-deep {
  .comfirm-remove-dialog {
    width: 327px !important;
    background: #18181b;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06),
      0px 1px 3px 0px rgba(0, 0, 0, 0.1);
    border-radius: 12px 12px 12px 12px;
    border: 1px solid rgba(229, 231, 235, 0.04);
    padding: 16px;

    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
      font-size: 14px;
      color: #a1a1aa;

      text-align: center;
      .error-content {
        max-width: 300px;
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        img {
          width: 24px;
          height: 24px;
          margin-right: 8px;
        }
      }

      .error-footer {
        margin-top: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .el-button {
          flex: 1;
          background: #165dff;
          border-radius: 12px 12px 12px 12px;
          border: none;
          font-weight: 500;
          font-size: 14px;
          color: #ecedee;
          &.el-button--primary {
            background: #165dff;
            &:hover {
              background: #165dff !important;
            }
            &:focus {
              background: #165dff !important;
            }
          }
          &.el-button--default {
            background: #3f3f46;
          }
        }
      }
    }
    .el-dialog__footer {
      display: none;
    }
  }
}
</style>
